<!-- Bar search -->
<ng-container *ngIf="appearance === 'bar'">
    <div class="flex items-center shrink-0">
        <button mat-icon-button *ngIf="!opened && isSearchVisible()" (click)="open(); $event.stopPropagation()">
            <mat-icon [svgIcon]="'search'" class="search-blink"></mat-icon>
            <span *ngIf="_searchService.getSearchInput().value"
                class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
                <span
                    class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-primary-500 text-indigo-50 text-xs font-medium">
                    {{ _searchService.getSearchInput().value.trim().substring(0,5)+"..." }}
                </span>
            </span>
        </button>
        <button id="filtroGeneral" class="relative" mat-icon-button type="button" (click)="eventoFiltro($event,filterGral)" #filterGral
            *ngIf="isFilterVisible()">
            <svg id="adjustments-vertical" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5" />
            </svg>
            <span *ngIf="_searchService.hasActiveFilter$ | async"
                class="absolute top-1.5 right-1.5 flex h-2.5 w-2.5">
                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-blue-600"></span>
            </span>
        </button>
    </div>
    <div class="absolute inset-0 flex items-center shrink-0 z-99 bg-card" *ngIf="opened" @slideInTop @slideOutTop>
        <mat-icon class="absolute ml-6 sm:ml-8" [svgIcon]="'search'"></mat-icon>
        <input id="barSearchInput" #barSearchInput class="w-full h-full px-16 sm:px-18" [formControl]="_searchService.getSearchInput()"
            autocomplete="off" [placeholder]="'Search...'"
            (ngModelChange)="this._searchService.getSearchText().next($event)" (keydown)="onKeydown($event)" />
        <!-- Limpiar -->
        <button *ngIf="_searchService.getSearchInput().value"
            class="absolute top-1/2 right-16 sm:right-20 shrink-0 w-10 h-10 -mt-5" mat-icon-button matTooltip="Limpiar"
            matTooltipPosition="above" (click)="clear()">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#64748B">
                <path
                    d="m456-320 104-104 104 104 56-56-104-104 104-104-56-56-104 104-104-104-56 56 104 104-104 104 56 56Zm-96 160q-19 0-36-8.5T296-192L80-480l216-288q11-15 28-23.5t36-8.5h440q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H360ZM180-480l180 240h440v-480H360L180-480Zm400 0Z" />
            </svg>
        </button>

        <!-- Cerrar -->
        <button class="absolute top-1/2 right-5 sm:right-7 shrink-0 w-10 h-10 -mt-5" mat-icon-button matTooltip="Cerrar"
            matTooltipPosition="above" (click)="close()">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#64748B">
                <path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z" />
            </svg>
        </button>
    </div>
</ng-container>

<!-- Basic search -->
<ng-container *ngIf="appearance === 'basic'">
    <div class="w-full sm:min-w-80">
        <mat-form-field class="fuse-mat-no-subscript w-full">
            <mat-icon matPrefix [svgIcon]="'search'"></mat-icon>
            <input #barSearchInput class="w-full h-full px-16 sm:px-18" [formControl]="_searchService.getSearchInput()"
                autocomplete="off" [placeholder]="'Search...'"
                (ngModelChange)="this._searchService.setSearchText($event)" (keydown)="onKeydown($event)" />
        </mat-form-field>
    </div>
</ng-container>